import React, { Fragment } from 'react';
import BackendHomeView from './BackendHomeView';

const BackendUserHome = () => {
    return (
        <Fragment>
            <BackendHomeView />
        </Fragment>
    )
}

export default BackendUserHome